import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-template",
  "use": "icon-template-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-template\"><path fill=\"#707070\" d=\"M960 960H64a32 32 0 0 1-32-32v-320a32 32 0 0 1 64 0V896h832V608a32 32 0 0 1 64 0v320a32 32 0 0 1-32 32z\" /><path fill=\"#707070\" d=\"M832 832H192a32 32 0 0 1-32-32v-704A32 32 0 0 1 192 64h640a32 32 0 0 1 32 32v704a32 32 0 0 1-32 32z m-608-64h576V128h-576z\" /><path fill=\"#707070\" d=\"M672 288h-320a32 32 0 0 1 0-64h320a32 32 0 0 1 0 64zM672 480h-320a32 32 0 0 1 0-64h320a32 32 0 0 1 0 64zM672 672h-320a32 32 0 0 1 0-64h320a32 32 0 0 1 0 64z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/template.svg
// module id = //Qc
// module chunks = 55